export default "__VITE_ASSET__99554109__"